import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SaleModel } from 'src/app/models/sale.model';

@Injectable({
    providedIn: 'root',
})
export class PrintReceiptService {
    private receiptTokitchen$ = new Subject<SaleModel>();
    private receiptToCustomer$ = new Subject<SaleModel>();
    constructor() {}
    printReceiptToKitchen(invoiceDate: SaleModel) {
        this.receiptTokitchen$.next(invoiceDate);
    }

    printReceiptToCustomer(invoiceDate: SaleModel) {
        this.receiptToCustomer$.next(invoiceDate);
    }

    getReceptTokitchan(): Observable<SaleModel> {
        return this.receiptTokitchen$.asObservable();
    }

    getReceiptToCustomer(): Observable<SaleModel> {
        return this.receiptToCustomer$.asObservable();
    }
}
